import { LimitCardTypeTokens } from '@voltmoney/schema';
export const args = {
    data: [
        {
            label: 'From Cams',
            limitAmount: 'Value: ₹60,00,000',
            secondrylabel: 'From KFintech',
            fetchedAmount: 'Value: ₹20,00,000',
            isView: true,
            showLottie: false,
            payload: 'CAMS',
            isPrimaryAction: true,
            isSecondryAction: true,
        },
        {
            label: 'From Cams2',
            limitAmount: 'Value: ₹60,00,000',
            secondrylabel: 'From KFintech',
            fetchedAmount: 'Value: ₹20,00,000',
            isView: true,
            payload: 'KARVY',
            showLottie: false,
            isPrimaryAction: false,
            isSecondryAction: true,
        },
    ],
    isView: false,
    label: 'From Cams2',
    limitAmount: '60,00,000',
    fetchedAmount: '20,00,000',
    showLottie: false,
};
export const argTypes = {
    type: {
        control: 'select',
        options: [
            ...Object.values(LimitCardTypeTokens).filter((k) => typeof k === 'string'),
        ],
    },
};
